import { call, put, delay } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { loadRegistryHistoryListBegin, loadRegistryHistoryListFailed, loadRegistryHistoryListSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import {
  BACKEND_URL, BACKEND_URL_V2, DEFAULT_ITEMS_OF_PAGE, LOADING_DELAY, SUBJECT_TYPE,
} from '../../../configs';
import addFilterQueryWithCondition, { addFilterQuery } from '../../../utils/addFilterQueryWithCondition';

export default function* loadRegistryHistoryList(action) {
  try {
    const { payload = {} } = action;
    const {
      limit = DEFAULT_ITEMS_OF_PAGE,
      page = 1,
      filter,
      sort,
    } = payload;
    let pool = {
      // subject_types: [SUBJECT_TYPE.CARRIER, SUBJECT_TYPE.ORDER_SERVICE, SUBJECT_TYPE.VEHICLE],
      // log_name: 'registry',
      limit,
      page,
    };
    if (typeof filter === 'object' && Object.keys(filter).length) {
      yield delay(LOADING_DELAY);
      // pool.filter = addFilterQueryWithCondition(filter);
      pool.filter = addFilterQuery({
        ...filter,
        log_name: 'registry',
      });
    }
    if (typeof sort === 'string' && sort.length) {
      pool = { ...pool, sort };
    }
    const url = `${BACKEND_URL_V2}/activity-logs/search`;
    yield put(loadRegistryHistoryListBegin());
    const dataResponse = yield makeRequest(url, pool, action, 'POST', true);
    const data = yield dataResponse.json();
    if (dataResponse.status === OK) {
      yield put(loadRegistryHistoryListSuccessful(data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(loadRegistryHistoryListFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(loadRegistryHistoryListFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  } finally {
    yield call(resolveActionPromise(action));
  }
}
